export default "__VITE_ASSET__RU_egmiD__"